var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJuusandoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6769 11.5634C0.84206 21.7539 -2.87343 37.0625 2.39494 51.2287C7.01374 63.6482 17.4334 72.2206 29.4363 75.0135C36.4459 76.6445 43.9955 76.3045 51.245 73.6084C70.908 66.2959 80.917 44.4201 73.6008 24.7475C68.9791 12.3201 58.5491 3.74475 46.5366 0.957422C33.6993 -2.02128 19.8389 2.07012 10.6769 11.5634ZM32.001 63.9063L43.9718 12.0646C52.4114 14.0252 59.6895 20.0334 62.92 28.7197C68.0413 42.4905 61.0349 57.8035 47.2709 62.9223C42.1809 64.8153 36.9135 65.0494 32.0148 63.9095C32.0102 63.9084 32.0056 63.9074 32.001 63.9063Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuusandoLogo);
export default __webpack_public_path__ + "static/media/juusando_logo.a6e3f783a030b6e5412d6466558e731b.svg";
export { ForwardRef as ReactComponent };